declare namespace $ {

	type $mol_view__event_bog_theme_toggle_1 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_theme_toggle['backdrop_click'] > ): ReturnType< $bog_theme_toggle['backdrop_click'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $bog_theme_picker__theme_auto_bog_theme_toggle_2 = $mol_type_enforce<
		ReturnType< $bog_theme_toggle['theme_auto'] >
		,
		ReturnType< $bog_theme_picker['theme_auto'] >
	>
	type $bog_theme_picker__close_bog_theme_toggle_3 = $mol_type_enforce<
		ReturnType< $bog_theme_toggle['picker_close'] >
		,
		ReturnType< $bog_theme_picker['close'] >
	>
	type $mol_button_minor__sub_bog_theme_toggle_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_theme_toggle_5 = $mol_type_enforce<
		ReturnType< $bog_theme_toggle['anchor_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_theme_toggle_6 = $mol_type_enforce<
		ReturnType< $bog_theme_toggle['clicked'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__event_bog_theme_toggle_7 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_theme_toggle['press_start'] > ): ReturnType< $bog_theme_toggle['press_start'] >,
			pointermove( next?: ReturnType< $bog_theme_toggle['press_move'] > ): ReturnType< $bog_theme_toggle['press_move'] >,
			pointerup( next?: ReturnType< $bog_theme_toggle['press_end'] > ): ReturnType< $bog_theme_toggle['press_end'] >,
			pointercancel( next?: ReturnType< $bog_theme_toggle['press_cancel'] > ): ReturnType< $bog_theme_toggle['press_cancel'] >,
			lostpointercapture( next?: ReturnType< $bog_theme_toggle['press_lost'] > ): ReturnType< $bog_theme_toggle['press_lost'] >,
		})  & ReturnType< $mol_button_minor['event'] >
		,
		ReturnType< $mol_button_minor['event'] >
	>
	export class $bog_theme_toggle extends $mol_pop {
		Icon( ): $mol_view
		anchor_hint( ): string
		clicked( next?: any ): any
		press_start( next?: any ): any
		press_move( next?: any ): any
		press_end( next?: any ): any
		press_cancel( next?: any ): any
		press_lost( next?: any ): any
		backdrop_click( next?: any ): any
		Backdrop( ): $mol_view
		picker_close( next?: any ): any
		Picker( ): $bog_theme_picker
		theme_auto( ): $bog_theme_auto
		showed( next?: boolean ): boolean
		align( ): string
		Anchor( ): $mol_button_minor
		Icon_light( ): $mol_icon_white_balance_sunny
		Icon_dark( ): $mol_icon_weather_night
		Icon_system( ): $mol_icon_monitor
		bubble_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=toggle.view.tree.d.ts.map